import { useParams } from 'react-router-dom';

import { ProfileSocialPostsAside, ProfileSocialPostsAsideSkeleton } from '@components/profile/ProfileSocialPostsAside';

import { useProfileSocialPostsAsideQuery } from './gql/graphql.v5.generated';

type Params = {
  username: string
};

interface Props {
  className?: string,
}

export const ProfilSocialPostsAsideContainer: React.FC<Props> = ({
  className,
}) => {
  const { username } = useParams<Params>();

  const { data, loading } = useProfileSocialPostsAsideQuery({
    variables: {
      username: username as string,
    },
    context: {
      v5: true,
      batch: true,
    },
    skip: !username,
  });

  if (loading) {
    return (
      <ProfileSocialPostsAsideSkeleton className={className} />
    );
  }

  return (
    <ProfileSocialPostsAside
      className={className}
      username={username}
      postsAmount={data?.user?.postsAmount}
      isSelfProfile={data?.me?.id === data?.user?.id}
    />
  );
};
